import { hyphenize } from "./hyphenize";

export function buildAriaDescribedBy(
  error: string,
  errorId: string,
  helpText: React.ReactNode,
  helpTextId: string
): string | undefined {
  return (
    [error ? errorId : null, helpText ? helpTextId : null]
      .filter(Boolean)
      .join(" ") || undefined
  );
}

export function buildTestIdPrefix(
  dataTestId: string | undefined,
  label: string
): string | undefined {
  return dataTestId ?? (label ? hyphenize(label) : undefined);
}
